import React from 'react';
import { Box, Text, Center, Button, useDisclosure, AspectRatio } from '@chakra-ui/react';

import WithAnimation from '@/components/Common/WithAnimation';
import WeddingFilter from '@/components/Section/Filter';
import Image from '@/components/Common/LazyImage';
import useSPH from '@hooks/useSPH';

import { ENABLE_WEDDING_FILTER, ENABLE_VIDEO_ALTERNATIVE } from '@/constants/feature-flags';
import { SPH_LOGO } from '@/constants/sph';

import Content from './Content';

function PhotoSection({ ...rest }) {
  const { isOpen, onClose, onOpen } = useDisclosure();
  const sph = useSPH();

  return (
    <Box bgColor="bgAlternative" padding="32px" {...rest}>
      <WithAnimation top>
        <Center>
          <Image src={SPH_LOGO} height="90px" />
        </Center>
      </WithAnimation>
      {/* Quote Sections */}
      <WithAnimation bottom>
        <Box textAlign="center" color="secondaryColorText" fontSize="md" margin="16px 0 24px 0">
          <Text>
            {`“Welcome to a new chapter of endless possibilities, treasured bonds, and unforgettable adventures! As we embark on this exciting journey, we invite you and your child to embrace a fresh start, experiencing extraordinary journey, and creating lasting memories. 
            Let's celebrate this incredible voyage together, filled with growth, joy, and lifelong connections!”`}
          </Text>
        </Box>
      </WithAnimation>
      {/* Cover Section */}
      <Box>
        {ENABLE_VIDEO_ALTERNATIVE && (
          <WithAnimation>
            <AspectRatio maxW="100%" ratio={16 / 9} borderRadius="16px">
              <iframe
                src="https://www.youtube.com/embed/tuS1LuPYQ_Q"
                allowFullScreen
                loading="lazy"
                style={{ borderRadius: '16px' }}
              />
            </AspectRatio>
          </WithAnimation>
        )}
        <WithAnimation>
          <Center>
            <Image
              src={sph.gallery[0].original}
              maxW={ENABLE_VIDEO_ALTERNATIVE ? '100%' : '90%'}
              borderRadius="16px"
              margin="16px 0"
            />
          </Center>
        </WithAnimation>
        <WithAnimation>
          <Center>
            <Image
              src={sph.gallery[1].original}
              maxW={ENABLE_VIDEO_ALTERNATIVE ? '100%' : '90%'}
              borderRadius="16px"
            />
          </Center>
        </WithAnimation>
      </Box>
      {/* Button Section */}
      <WithAnimation>
        <Center>
          <Button
            colorScheme="blackAlpha"
            fontWeight="light"
            color="white"
            bgColor="mainColorText"
            margin="24px 0"
            onClick={() => onOpen()}
          >
            School Gallery
          </Button>
        </Center>
      </WithAnimation>
      {/* Content gallery */}
      <Content isOpen={isOpen} onClose={onClose} />
      {ENABLE_WEDDING_FILTER && <WeddingFilter />}
    </Box>
  );
}

export default React.memo(PhotoSection);
